export class SystemAccountCreationByInviteModel {
  inviteId: number;
  name: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  parentOrganizationId: number;
  organizationCode: string;
  organizationName: string;
  role: string;
  associatedOrganizationId: number;
  statusSystemAccountIdSintra: boolean;
  systemAccountIdSintra: string;
}
